import {
  mixinDialogActions,
  mixinDialogGetters,
  mixinDialogMutations
} from '@/mixins/vuexDialogs'
import Cookies from 'js-cookie'
import { getMathHeaders, getQueryParam } from '@/utils/helpers'

export default {
  namespaced: true,
  state: {
    isAuthenticated: Cookies.get('dolphinAntyAccessToken') || '',
    isEmailConfirmed: false,
    loading: false,
    error: null
  },

  getters: {
    ...mixinDialogGetters,

    isAuthenticated: state => state.isAuthenticated,
    isEmailConfirmed: state => state.isEmailConfirmed,
    loading: state => state.loading,
    registrationToken: state => state.registrationToken,
    errorMessage: state => state.errorMessage
  },

  mutations: {
    ...mixinDialogMutations,

    SET_IS_AUTHENTICATED: (state, payload) => {
      state.isAuthenticated = payload
    },

    SET_IS_EMAIL_CONFIRMED: (state, payload) => {
      state.isEmailConfirmed = payload
    },

    SET_LOADING: (state, payload) => {
      state.loading = payload
    },
  },

  actions: {
    ...mixinDialogActions,

    async setIsAuthenticated(context, payload) {
      context.commit('SET_IS_AUTHENTICATED', payload)
    },
    
    async setIsEmailConfirmed(context, payload) {
      context.commit('SET_IS_EMAIL_CONFIRMED', payload)
    },
    
    async setLoading(context, payload) {
      context.commit('SET_LOADING', payload)
    },
    
    async getRegistrationToken(context, payload) {
      const utms = Cookies.get('utms')

      if (utms) {
        const utmObject = JSON.parse(utms)
        Object.assign(payload, utmObject)
      }

      const data = {
        ...payload,
        language_browser: window.navigator.language,
        language_landing: localStorage.getItem('lang') || 'en',
        cookies: document.cookie,
        yandexMetrica: Cookies.get('_ym_uid') || '',
        ref: Cookies.get('a') ? Cookies.get('a') : '',
        ip: '',
        referral_source: Cookies.get('referral_source') || '',
      }
      const admitad_uid = Cookies.get('admitad_uid')
      if(admitad_uid){
        data.admitad_uid = admitad_uid
      } else {
        const admitad_uid = getQueryParam('admitad_uid');
        if(admitad_uid) {
          data.admitad_uid = admitad_uid
        }

      }
      const mathHeaders = await getMathHeaders();
      const response = await this._vm.api.post( '/auth/register',
        data,
        { headers: {...this._vm.api.headers, ...mathHeaders} }
      )
      
      if (response.status === 200) {
        localStorage.setItem('confirmToken', response.data.token)
        localStorage.setItem('confirmRefreshToken', response.data.refresh_token)
      }
    },
    
    async sendEmailVerificationNotification(context, payload) {
      await this._vm.apiV2.post(
        '/email/verification-notification',
        {
          count: payload.count,
        },
        {
          headers: {
            Authorization: `Bearer ${payload.accessToken}`
          }
        }
      )
    },

    async forgotPassword(context, payload) {
      const mathHeaders = await getMathHeaders();
      await this._vm.api.post('/auth/recover-password',
        payload,
        { headers: {...this._vm.api.headers, ...mathHeaders} }
      )
    },

    async resetPassword(context, payload) {
      const mathHeaders = await getMathHeaders();
      await this._vm.api.post('/auth/reset-password',
        payload,
        { headers: {...this._vm.api.headers, ...mathHeaders} }
      )
    },

    async checkPromo(context, payload) {
      const mathHeaders = await getMathHeaders();
      return this._vm.api.post(
        '/auth/register/check-promo',
        { promo: payload },
        { headers: {...this._vm.api.headers, ...mathHeaders} }
      )
    },
  }
}
